import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * ローディング表示制御サービス
 * @export
 * @class LoadingService
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  /** ローディング表示フラグ */
  private _isLoading = new Subject<boolean>();

  constructor() { }

  /**
   * ローディング表示フラグのゲッター
   * @readonly
   * @memberof LoadingService
   */
  get isLoading() {
    return this._isLoading;
  }

  /**
   * ローディング画面を表示する
   * @memberof LoadingService
   */
  public show(): void {
    this._isLoading.next(true);
  }

  /**
   * ローディング画面を隠す
   * @memberof LoadingService
   */
  public hide(): void {
    this._isLoading.next(false);
  }
}
